import { getUserNotificationListByParams, updateNotificationDetail } from '@/service/notificationService';
import Utils, { findIndexInArrayById, isAdminUser } from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import NotificationEventType from '@/common/constant/NotificationEventType';
import {
    handleClickViewTicketDetail,
    viewTicketKnowledgeDetail
} from '@/component/ticketList/handler/TicketHandler';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Constant from '@/common/constant/Constant';
import { onChangeProjectInuse } from '@/component/multiPanel/handler/WrapPanelHandler';
import { getCorporationById } from '@/service/organizationService';
import { I18n } from 'aws-amplify';
import { getNotificationMsg } from './SubsciptionHandler';
import {  isDisplayIconChat } from '@/component/chatThread/handler/DetailTicketHandler';
import { getListAllProjectOfUser } from '@/service/projectService';

const MAIL_CODE_ALWAYS_OPEN_HELPDESK_PANEL = [
    Constant.NOTI_MAIL_CODE.NOTI_MAIL_CREATE_TICKET_EMAIL,
    Constant.NOTI_MAIL_CODE.NOTI_MAIL_RECEIVE_EMAIL_FROM_PERSIONAL_AND_CREATE_EMAIL_TICKET,
    Constant.NOTI_MAIL_CODE.NOTI_MAIL_RECEIVE_EMAIL_FROM_PROJECT_AND_CREATE_EMAIL_TICKET,
]

export const onReadNotification = async (argsAll, notification) => {
    if (!notification?.footPrint?.includes(argsAll.userDetail.id)) {
        let footPrint = cloneDeep(notification.footPrint ? notification.footPrint : []);
        if (!Utils.isEmptyArray(footPrint)) {
            footPrint = [argsAll.userDetail.id];
        } else {
            footPrint.push(argsAll.userDetail.id);
        }

        await updateNotificationDetail(argsAll.API, notification.id, { footPrint });

        //update list all notification
        let notificationListClone = cloneDeep(argsAll.notificationList);
        let indexNotify = findIndexInArrayById(notification.id, notificationListClone);
        if (indexNotify !== -1) {
            notificationListClone[indexNotify].footPrint = footPrint;
            argsAll.setNotificationList(notificationListClone);
        }

        //update list unread
        let notificationUnreadListClone = cloneDeep(argsAll.notificationUnReadList);
        let indexNotifyUnread = findIndexInArrayById(notification.id, notificationUnreadListClone);
        if (indexNotifyUnread !== -1) {
            notificationUnreadListClone.splice(indexNotifyUnread, 1);
            argsAll.setNotificationUnReadList(notificationUnreadListClone);
        }
    }

    const isReadNotification = true;
    await openNotificationDetail({...argsAll, isReadNotification}, notification);
};

export const openNotificationDetail = async (argsAll, notification) => {
    console.log('openNotificationDetail notification', notification)

    let projectIdOfUserList = [];
    argsAll?.projectList?.forEach(project => {
        projectIdOfUserList.push(project.id);
    });
    let sourceInfo = Utils.convertJSONDataToObject(notification.sourceInfo);
    console.log('sourceInfo', sourceInfo)
    
    const ticketDetail = {
        id: sourceInfo?.ticketId,
        outline: JSON.stringify({ jp: sourceInfo?.ticketOutline }),
        affiliationOrganization: sourceInfo?.ticketAffiliationOrganization,
        affiliationProject: sourceInfo?.ticketAffiliationProject,

        ticketType: sourceInfo?.ticketType,
        public: sourceInfo?.public || Constant.TICKET_PUBLIC.PUBLIC,
        deletedAt: sourceInfo?.deletedAt
    }

    argsAll.ticketDetail = ticketDetail;
    argsAll.sourceInfo = sourceInfo;

    let isOpenChat = isDisplayIconChat({
        detailTicket: {...ticketDetail}
    });
    console.log('isOpenChat', isOpenChat);

    let ticketId = '';
    let ticketOutline = '';
    let ticketInfo = {};
    
    console.log('notification.eventType', notification.eventType)
    switch (notification.eventType) {
        case NotificationEventType.TICKET_NEW:
            //this using for tickets QA
            if (
                [
                    Constant.TICKET_TYPE.QA,
                    Constant.TICKET_TYPE.INTERNAL_QA,
                    Constant.TICKET_TYPE.EXTERNAL_QA,
                    Constant.TICKET_TYPE.DELEGATE,
                    Constant.TICKET_TYPE.ESCALATION
                ].includes(sourceInfo?.ticketType)
            ) {
                const { isOpenPanelHelpDesk, affiliationProjectId, projectOriginId } = sourceInfo;
                let selectedProject = {};
                ticketId = sourceInfo?.ticketId;
                ticketOutline = '';
                try {
                    ticketOutline = JSON.parse(notification?.sourceInfo)?.ticketOutline;
                } catch (err) {
                    ticketOutline = '';
                }
                ticketInfo = {
                    outline: JSON.stringify({
                        jp: ticketOutline
                    })
                };
                argsAll.ticketInfo = ticketInfo;
                argsAll.ticketType = sourceInfo?.ticketType;

                if (isOpenPanelHelpDesk) {
                    //switch to selected project to desk project
                    argsAll.panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
                    selectedProject = argsAll.projectList?.find(x => x.id === affiliationProjectId);

                    //change selected project when current project is not desk project
                    if (argsAll?.projectDetail?.id != affiliationProjectId)
                        await onChangeProjectInuse(argsAll, selectedProject);
                } else {
                    //switch to selected project to desk project
                    argsAll.panelType = Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST;
                    selectedProject = argsAll.projectList?.find(x => x.id === projectOriginId);

                    //change selected project when current project is not customer project
                    if (argsAll?.projectDetail?.id !== projectOriginId)
                        await onChangeProjectInuse(argsAll, selectedProject);
                }

                //open ticket detail
                await handleClickViewTicketDetail(
                    argsAll,
                    argsAll.API,
                    ticketId,
                    { ticketOutline: sourceInfo?.ticketOutline },
                    null,
                    null,
                    argsAll.userDetail,
                    argsAll.addNewPanel,
                    selectedProject,
                    isOpenChat
                );

                return true;
            }

            if (
                [Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(
                    sourceInfo.ticketType
                )
            ) {
                await viewTicketKnowledgeDetail(argsAll, sourceInfo.ticketId, argsAll.addNewPanel);
            } else {
                ticketId = sourceInfo?.ticketId;
                argsAll.panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
                if (
                    (argsAll.userDetail.id === notification.notificationRange &&
                        sourceInfo.projectOrigin !== sourceInfo.customer &&
                        argsAll?.projectDetail?.id !== notification.affiliationProject)
                ) {
                    argsAll.panelType = Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST;
                }

                if (
                    [
                        Constant.TICKET_TYPE.BROADCAST_PARENT,
                        Constant.TICKET_TYPE.BROADCAST_CHILD,
                    ].includes(sourceInfo.ticketType) &&
                    sourceInfo.projectOrigin !== sourceInfo.customer
                ) {
                    argsAll.panelType = Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST;
                }

                // For email ticket
                if (MAIL_CODE_ALWAYS_OPEN_HELPDESK_PANEL.includes(sourceInfo?.mailCode)) {
                    argsAll.panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
                }

                ticketOutline = '';
                try {
                    ticketOutline = JSON.parse(notification.sourceInfo).ticketOutline;
                } catch (err) {
                    ticketOutline = '';
                }
                ticketInfo = {
                    outline: JSON.stringify({
                        jp: ticketOutline
                    })
                };
                argsAll.ticketInfo = ticketInfo;
                argsAll.ticketType = sourceInfo?.ticketType;

                if (notification.objectType === Constant.NOTIFICATION_OBJECT_TYPE.DELEGATE) {
                    if (sourceInfo.projectOrigin !== argsAll?.projectDetail?.id) {
                        //switch to project helpdesk
                        let projectInuseUpdate = argsAll.projectList?.find(
                            x => x.id === sourceInfo.projectOrigin
                        );
                        await onChangeProjectInuse(argsAll, projectInuseUpdate);
                    } else {
                        argsAll.panelType = Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST;
                    }

                    await handleClickViewTicketDetail(
                        argsAll,
                        argsAll.API,
                        ticketId,
                        {ticketOutline: sourceInfo?.ticketOutline},
                        null,
                        null,
                        argsAll.userDetail,
                        argsAll.addNewPanel,
                        argsAll.projectDetail,
                        isOpenChat
                    );
                } else {
                    //projectInuse is project helpdesk of ticket
                    if (sourceInfo.projectTarget?.includes(argsAll.projectDetail?.id)) {
                        await handleClickViewTicketDetail(
                            argsAll,
                            argsAll.API,
                            ticketId,
                            {ticketOutline: sourceInfo?.ticketOutline},
                            null,
                            null,
                            argsAll.userDetail,
                            argsAll.addNewPanel,
                            argsAll.projectDetail,
                            isOpenChat
                        );
                    } else {
                        if (!sourceInfo.projectTarget) return;
                        //switch to project helpdesk
                        let projectInuseUpdate;
                        for (const projectTargetId of sourceInfo.projectTarget) {
                            projectInuseUpdate = argsAll?.projectList.find(
                                x => x.id === projectTargetId
                            );
                            if (!Utils.isEmptyObject(projectInuseUpdate)) break;
                        }

                        await onChangeProjectInuse(argsAll, projectInuseUpdate);

                        setTimeout(async() => {
                            //open ticket detail
                            await handleClickViewTicketDetail(
                                argsAll,
                                argsAll.API,
                                ticketId,
                                {ticketOutline: sourceInfo?.ticketOutline},
                                null,
                                null,
                                argsAll.userDetail,
                                argsAll.addNewPanel,
                                projectInuseUpdate,
                                isOpenChat
                            );
                        }, 2000);
                    }
                }
            }
            break;

        case NotificationEventType.TICKET_UPDATE:
            //this using for tickets QA
            if (
                [
                    Constant.TICKET_TYPE.QA,
                    Constant.TICKET_TYPE.INTERNAL_QA,
                    Constant.TICKET_TYPE.EXTERNAL_QA,
                    Constant.TICKET_TYPE.DELEGATE,
                    Constant.TICKET_TYPE.ESCALATION
                ].includes(sourceInfo?.ticketType)
            ) {
                const { isOpenPanelHelpDesk, affiliationProjectId, projectOriginId } = sourceInfo;
                let selectedProject = {};
                ticketOutline = '';
                ticketId = sourceInfo?.ticketId;
                try {
                    ticketOutline = JSON.parse(notification?.sourceInfo)?.ticketOutline;
                } catch (err) {
                    ticketOutline = '';
                }
                ticketInfo = {
                    outline: JSON.stringify({
                        jp: ticketOutline
                    })
                };
                argsAll.ticketInfo = ticketInfo;
                argsAll.ticketType = sourceInfo?.ticketType;

                if (isOpenPanelHelpDesk) {
                    //switch to selected project to desk project
                    argsAll.panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
                    selectedProject = argsAll.projectList?.find(x => x.id === affiliationProjectId);

                    //change selected project when current project is not desk project
                    if (argsAll?.projectDetail?.id != affiliationProjectId)
                        await onChangeProjectInuse(argsAll, selectedProject);
                } else {
                    //switch to selected project to desk project
                    argsAll.panelType = Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST;
                    selectedProject = argsAll.projectList?.find(x => x.id === projectOriginId);

                    //change selected project when current project is not customer project
                    if (argsAll?.projectDetail?.id !== projectOriginId)
                        await onChangeProjectInuse(argsAll, selectedProject);
                }

                //open ticket detail
                await handleClickViewTicketDetail(
                    argsAll,
                    argsAll.API,
                    ticketId,
                    { ticketOutline: sourceInfo?.ticketOutline },
                    null,
                    null,
                    argsAll.userDetail,
                    argsAll.addNewPanel,
                    selectedProject,
                    isOpenChat
                );

                return true;
            }
            
            ticketId = sourceInfo?.ticketId;
            argsAll.panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
            ticketOutline = '';
            try {
                ticketOutline = JSON.parse(notification.sourceInfo).ticketOutline;
            } catch (err) {
                ticketOutline = '';
            }
            ticketInfo = {
                outline: JSON.stringify({
                    jp: ticketOutline
                })
            };
            argsAll.ticketInfo = ticketInfo;
            argsAll.ticketType = sourceInfo?.ticketType;
            if (sourceInfo.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER) {
                argsAll.approveFlag = sourceInfo.approveFlag;

                //projectInuse is project helpdesk of ticket
                if (sourceInfo.projectOrigin === argsAll?.projectDetail?.id) {
                    await handleClickViewTicketDetail(
                        argsAll,
                        argsAll.API,
                        ticketId,
                        {ticketOutline: sourceInfo?.ticketOutline},
                        null,
                        null,
                        argsAll.userDetail,
                        argsAll.addNewPanel,
                        argsAll.projectDetail,
                        isOpenChat
                    );
                } else {
                    //switch to project helpdesk
                    let projectTargetId = sourceInfo.projectTarget[0];
                    let projectInuseUpdate = argsAll.projectList.find(
                        x => x.id === projectTargetId
                    );
                    await onChangeProjectInuse(argsAll, projectInuseUpdate);
                    //open ticket detail
                    await handleClickViewTicketDetail(
                        argsAll,
                        argsAll.API,
                        {ticketOutline: sourceInfo?.ticketOutline},
                        null,
                        null,
                        null,
                        argsAll.userDetail,
                        argsAll.addNewPanel,
                        projectInuseUpdate,
                        isOpenChat
                    );
                }
            } else if (
                [Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(
                    sourceInfo.ticketType
                )
            ) {
                argsAll.panelType = Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL;
                argsAll.isCustomer = false;
                await viewTicketKnowledgeDetail(argsAll, sourceInfo.ticketId, argsAll.addNewPanel);
            } else {
                let targetProjectOfNotification =
                    Utils.getPrefixOfId(notification.notificationRange) === 'project'
                        ? notification.notificationRange
                        : sourceInfo.projectOrigin;
                if (
                    sourceInfo?.isNotificationToPIC ||
                    (
                        sourceInfo.projectOrigin === sourceInfo.customer &&
                        argsAll?.projectDetail?.id !== sourceInfo.projectOrigin &&
                        ![Constant.TICKET_TYPE.BROADCAST_PARENT, Constant.TICKET_TYPE.BROADCAST_CHILD].includes(sourceInfo.ticketType)
                    )
                ) {
                    targetProjectOfNotification = notification.affiliationProject;
                }
                if (
                    Utils.getPrefixOfId(notification.notificationRange) === 'user' &&
                    argsAll.userDetail.id === notification.notificationRange &&
                    sourceInfo.projectOrigin !== sourceInfo.customer
                ) {
                    targetProjectOfNotification = sourceInfo.customer;
                }
                argsAll.panelType =
                    targetProjectOfNotification === notification.affiliationProject ||
                    argsAll?.projectDetail?.id === notification.affiliationProject ||
                    sourceInfo.ticketType === Constant.TICKET_TYPE.EMAIL
                        ? Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
                        : Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;

                if (
                    [
                        Constant.TICKET_TYPE.BROADCAST_PARENT,
                        Constant.TICKET_TYPE.BROADCAST_CHILD,
                    ].includes(sourceInfo.ticketType) &&
                    sourceInfo.projectOrigin !== sourceInfo.customer
                ) {
                    argsAll.panelType = Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST;
                }

                if (targetProjectOfNotification === argsAll?.projectDetail?.id) {
                    await handleClickViewTicketDetail(
                        argsAll,
                        argsAll.API,
                        ticketId,
                        {ticketOutline: sourceInfo?.ticketOutline},
                        null,
                        null,
                        argsAll.userDetail,
                        argsAll.addNewPanel,
                        argsAll.projectDetail,
                        isOpenChat
                    );
                } else {
                    if (sourceInfo.projectOrigin !== sourceInfo.customer) {
                        let targetProject;
                        if (argsAll.userDetail.type === Constant.USER_TYPE.CUSTOMER) {
                            targetProject = argsAll.projectList.find(
                                x => x.type === Constant.PROJECT_TYPE.CUSTOMER
                            );
                        } else {
                            targetProject = argsAll.projectList.find(
                                x => x.type === Constant.PROJECT_TYPE.BASE
                            );
                        }

                        if (argsAll?.projectDetail?.id === sourceInfo.projectOrigin) {
                            targetProjectOfNotification =
                                Utils.getPrefixOfId(sourceInfo.projectOrigin) === 'project'
                                    ? sourceInfo.projectOrigin
                                    : targetProject.id;
                        } else {
                            targetProjectOfNotification =
                                Utils.getPrefixOfId(sourceInfo.customer) === 'project'
                                    ? sourceInfo.customer
                                    : targetProject.id;
                            if (sourceInfo.ticketType === Constant.TICKET_TYPE.EMAIL && sourceInfo.customer === Constant.NA) {
                                targetProjectOfNotification = sourceInfo.projectOrigin
                            }
                        }
                    }

                    let projectInuseUpdate = argsAll.projectList.find(
                        x => x.id === targetProjectOfNotification
                    );
                    await onChangeProjectInuse(argsAll, projectInuseUpdate);

                    setTimeout(async() => {
                        //open ticket detail
                        await handleClickViewTicketDetail(
                            argsAll,
                            argsAll.API,
                            ticketId,
                            {ticketOutline: sourceInfo?.ticketOutline},
                            null,
                            null,
                            argsAll.userDetail,
                            argsAll.addNewPanel,
                            projectInuseUpdate,
                            isOpenChat
                        );
                    }, 2000)
                }
            }
            break;
        case NotificationEventType.UPDATE_PIC:
            ticketId = sourceInfo?.ticketId;
            argsAll.panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
            ticketOutline = '';
            try {
                ticketOutline = JSON.parse(notification.sourceInfo).ticketOutline;
            } catch (err) {
                ticketOutline = '';
            }
            ticketInfo = {
                outline: JSON.stringify({
                    jp: ticketOutline
                })
            };
            argsAll.ticketInfo = ticketInfo;
            argsAll.ticketType = sourceInfo?.ticketType;
            //projectInuse is project helpdesk of ticket
            if (notification.affiliationProject === argsAll?.projectDetail?.id) {
                await handleClickViewTicketDetail(
                    argsAll,
                    argsAll.API,
                    ticketId,
                    {ticketOutline: sourceInfo?.ticketOutline},
                    null,
                    null,
                    argsAll.userDetail,
                    argsAll.addNewPanel,
                    argsAll.projectDetail,
                    isOpenChat
                );
            } else {
                //switch to project helpdesk
                let projectTargetId = notification.affiliationProject;
                let projectInuseUpdate = argsAll.projectList.find(x => x.id === projectTargetId);
                await onChangeProjectInuse(argsAll, projectInuseUpdate);
                //open ticket detail
                await handleClickViewTicketDetail(
                    argsAll,
                    argsAll.API,
                    ticketId,
                    {ticketOutline: sourceInfo?.ticketOutline},
                    null,
                    null,
                    argsAll.userDetail,
                    argsAll.addNewPanel,
                    projectInuseUpdate,
                    isOpenChat
                );
            }
            break;

        // user
        case NotificationEventType.ADMIN_ON:
        case NotificationEventType.ADMIN_OFF:
        case NotificationEventType.OWNER_ON:
        case NotificationEventType.OWNER_OFF:
        case NotificationEventType.GENERAL_ON:
        case NotificationEventType.GENERAL_OFF:
        case NotificationEventType.MEMBER_ON:
        case NotificationEventType.MEMBER_OFF:
        case NotificationEventType.PM_ON:
        case NotificationEventType.PM_OFF:
        case NotificationEventType.USER_TYPE_CHANGE:
            //open panel user profile
            openPanelUserProfile(argsAll);
            break;
        case NotificationEventType.MESSAGE_NEW:
        case NotificationEventType.MESSAGE_ATTACHMENT_NEW:
        case NotificationEventType.MESSAGE_MENTION_TO:
            if (sourceInfo.ticketType === Constant.TICKET_TYPE.KNOWLEDGE) {
                await argsAll.handleOpenKnowledgeChatThreadPanel(sourceInfo);
                return;
            }
            if (
                sourceInfo.ticketType === Constant.TICKET_TYPE.KNOWLEDGE ||
                sourceInfo.ticketType === Constant.TICKET_TYPE.MASTER_KNOWLEDGE
            ) {
                argsAll.addNewPanel({
                    type: Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
                    tabId: ticketDetail.id,
                    props: argsAll.props,
                    ticketId: ticketDetail.id,
                    ticketOutline: ticketDetail.outline
                });
            } else {
                let projectTargetId;
                const prefixOfNotificationRange = Utils.getPrefixOfId(
                    notification?.notificationRange
                );
                if (prefixOfNotificationRange === 'user') {
                    if (argsAll?.userDetail?.type === Constant.USER_TYPE.CUSTOMER) {
                        const projectCustomer = argsAll?.projectList?.find(project => {
                            return project.type === Constant.PROJECT_TYPE.CUSTOMER;
                        });

                        projectTargetId = projectCustomer.id;
                    }
                    if (
                        argsAll?.userDetail?.type === Constant.USER_TYPE.INTERNAL ||
                        Utils.isGeneralUserWithoutGuest(argsAll?.userDetail)
                    ) {
                        const projectBase = argsAll?.projectList?.find(project => {
                            return project.type === Constant.PROJECT_TYPE.BASE;
                        });
                        const listNoticeEventTypeWithUserGeneral = [
                            NotificationEventType.MESSAGE_MENTION_TO,
                            NotificationEventType.MESSAGE_NEW,
                            NotificationEventType.MESSAGE_ATTACHMENT_NEW
                        ];
                        if (
                            Utils.isGeneralUserWithoutGuest(argsAll?.userDetail) &&
                            listNoticeEventTypeWithUserGeneral.includes(notification.eventType)
                        ) {
                            let listProjectOfNoti = [
                                sourceInfo?.projectOrigin,
                                sourceInfo?.affiliationProject
                            ];
                            if (!Utils.isEmptyArray(sourceInfo?.projectTarget)) {
                                listProjectOfNoti = [
                                    ...listProjectOfNoti,
                                    ...sourceInfo?.projectTarget
                                ];
                            }
                            projectTargetId = listProjectOfNoti?.map(projectId => {
                                if (projectIdOfUserList.includes(projectId)) return projectId;
                            });
                            projectTargetId =
                                projectTargetId.length === 1
                                    ? projectTargetId[0]
                                    : argsAll?.projectDetail?.id;
                        } else {
                            projectTargetId = projectBase.id;
                        }
                    }
                }

                if (prefixOfNotificationRange === 'project') {
                    projectTargetId = notification.notificationRange;
                }

                if (Utils.isEmptyString(projectTargetId)) {
                    projectTargetId = argsAll?.projectDetail?.id;
                }

                let chatThreadPanelType = Constant.PANEL_TYPE.HELPDESK_CHATTHREAD;

                if (
                    (sourceInfo.projectOrigin !== sourceInfo.customer &&
                        Utils.getPrefixOfId(sourceInfo.customer) === 'project') ||
                    !sourceInfo.projectTarget?.includes(argsAll?.projectDetail?.id)
                ) {
                    chatThreadPanelType = Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;
                }

                if (
                    sourceInfo.projectOrigin !== sourceInfo.customer &&
                    !sourceInfo.projectTarget?.includes(argsAll?.projectDetail?.id)
                ) {
                    let targetProject;
                    if (argsAll.userDetail.type === Constant.USER_TYPE.CUSTOMER) {
                        targetProject = argsAll.projectList.find(
                            x => x.type === Constant.PROJECT_TYPE.CUSTOMER
                        );
                    } else {
                        targetProject = argsAll.projectList.find(
                            x => x.type === Constant.PROJECT_TYPE.BASE
                        );
                    }

                    if (argsAll?.projectDetail?.id === sourceInfo.projectOrigin) {
                        projectTargetId =
                            Utils.getPrefixOfId(sourceInfo.projectOrigin) === 'project'
                                ? sourceInfo.projectOrigin
                                : targetProject.id;
                    } else {
                        projectTargetId =
                            Utils.getPrefixOfId(sourceInfo.customer) === 'project'
                                ? sourceInfo.customer
                                : targetProject.id;
                    }
                    chatThreadPanelType = Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;
                }
                
                // Ticket notice
                if (
                    ticketDetail?.ticketType === Constant.TICKET_TYPE.BROADCAST_PARENT &&
                    (ticketDetail?.affiliationProject === notification?.notificationRange ||
                        ticketDetail?.affiliationProject === sourceInfo.projectTargetId)
                ) {
                    chatThreadPanelType = Constant.PANEL_TYPE.HELPDESK_CHATTHREAD;
                    projectTargetId = sourceInfo.projectTargetId;
                }

                if (
                    ticketDetail?.ticketType === Constant.TICKET_TYPE.BROADCAST_PARENT &&
                    sourceInfo.projectTargetId &&
                    ticketDetail?.affiliationProject !== sourceInfo.projectTargetId
                ) {
                    chatThreadPanelType = Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;
                    projectTargetId = sourceInfo.projectTargetId;
                }

                //this using for tickets QA
                if (
                    [
                        Constant.TICKET_TYPE.QA,
                        Constant.TICKET_TYPE.INTERNAL_QA,
                        Constant.TICKET_TYPE.EXTERNAL_QA,
                        Constant.TICKET_TYPE.DELEGATE,
                        Constant.TICKET_TYPE.ESCALATION
                    ].includes(sourceInfo?.ticketType)
                ) {
                    const {
                        isOpenPanelHelpDesk,
                        affiliationProjectId,
                        projectOriginId
                    } = sourceInfo;

                    if (isOpenPanelHelpDesk) {
                        //switch to selected project to desk project
                        chatThreadPanelType = Constant.PANEL_TYPE.HELPDESK_CHATTHREAD;
                        projectTargetId = affiliationProjectId;
                    } else {
                        //switch to selected project to desk project
                        chatThreadPanelType = Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;
                        projectTargetId = projectOriginId;
                    }
                }

                if ([Constant.TICKET_TYPE.EMAIL, Constant.TICKET_TYPE.EMAIL_REPLY].includes(sourceInfo?.ticketType)) {
                    projectTargetId = sourceInfo.projectTarget[0]
                    chatThreadPanelType = Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                }

                let projectInuseUpdate = argsAll.projectList.find(x => x.id === projectTargetId);
                if (projectTargetId !== argsAll?.projectDetail?.id) {
                    await onChangeProjectInuse(argsAll, projectInuseUpdate);
                }
                // console.log('177259 done open chatThread', argsAll.props)
                let openDetailPanelProps = {
                    API: argsAll.props.API,
                    ticketId: ticketDetail.id,
                    panelType: argsAll.props?.panelType,
                    history: argsAll.props?.history,
                }
                // open chatThread
                const isReadNotification = argsAll.isReadNotification;
                const timer1 = isReadNotification ? 0 : 3000;
                const timer2 = isReadNotification ? 1500 : 2000;
                let newPanelId = Date.now().toString();
                // open chatThread
                setTimeout(async () => {
                    let ticketDetailPanelType = chatThreadPanelType === Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                    ? Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
                    : Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;

                    await argsAll.addNewPanel({
                        type: ticketDetailPanelType,
                        tabId: ticketDetail.id,
                        props: openDetailPanelProps,
                        ticketId: ticketDetail.id,
                        newPanelId: newPanelId,
                        ticketOutline: ticketDetail.outline,
                        isDraft: ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT,
                        isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false,
                        isEmailTicket: [Constant.TICKET_TYPE.EMAIL, Constant.TICKET_TYPE.EMAIL_REPLY,].includes(ticketDetail?.ticketType)
                    });

                    if (isOpenChat) {
                        setTimeout(async () => {
                            await argsAll.addNewPanel({
                                type: chatThreadPanelType,
                                tabId: ticketDetail.id,
                                props: openDetailPanelProps,
                                currentPanelId: newPanelId,
                                ticketId: ticketDetail.id,
                                ticketOutline: ticketDetail.outline,
                                selectThreadId: sourceInfo.chatThreadId,
                                isDraft: ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT,
                                isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false,
                                openRelatePanelType: ticketDetailPanelType
                            });
                        }, timer2)
                    }
                }, timer1);
            }
            break;
        case NotificationEventType.EXCEED_MAX_TICKET:
        case NotificationEventType.EXCEED_MAX_GENERAL_USER_WHEN_CREATE_TICKET:
        case NotificationEventType.EXCEED_MAX_STORAGE:
            argsAll.addNewPanel({
                type: Constant.PANEL_TYPE.SYSTEM_MANAGEMENT,
                tabId: Constant.PANEL_TYPE.SYSTEM_ORG_PROFILE,
                props: argsAll.props
            });
            break;
        case NotificationEventType.MENTION_IN_CHAT_KNOWLEDGE:
        case NotificationEventType.KNOWLEDGE_CHAT_MESSAGE_NEW:
            if (
                !Utils.isEmptyString(sourceInfo.projectFocus) &&
                sourceInfo.projectFocus !== 'any'
            ) {
                if (sourceInfo.projectFocus !== argsAll?.projectDetail?.id) {
                    let projectFocus = argsAll.projectList.find(
                        x => x.id === sourceInfo.projectFocus
                    );

                    if (Utils.isEmptyString(projectFocus)) {
                        argsAll.setIsShowConfirmModal(true);
                        return;
                    }

                    await onChangeProjectInuse(argsAll, projectFocus);
                }
            }

            if (
                sourceInfo.ticketType === Constant.TICKET_TYPE.KNOWLEDGE ||
                Utils.getPrefixOfId(sourceInfo.ticketId) === 'knowledge'
            ) {
                await argsAll.handleOpenKnowledgeChatThreadPanel(sourceInfo);
                return;
            }

            await argsAll.addNewPanel({
                type: Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
                tabId: sourceInfo.ticketId,
                props: argsAll.props,
                ticketId: sourceInfo.ticketId,
                ticketOutline: sourceInfo.ticketTitle
            });
            break;
        case NotificationEventType.NOTI_UPDATE_CONTRACT_BANK_TRANSFER:
        case NotificationEventType.NOTI_UPDATE_CONTRACT_CREDIT_CARD:
        case NotificationEventType.NOTI_ORG_REGISTERED_TRIAL:
        case NotificationEventType.NOTI_ORG_STARTED_TRIAL:
            let validateCorp = await validateBeforeViewCorporationRootSide(argsAll.API, sourceInfo.corporationId);
            if (!validateCorp) {
                if (argsAll?.setIsDataChange) {
                    argsAll.setIsDataChange({
                        status: true,
                        msg: I18n.get('MSG-NOTI-OF-DELETED-ORG')
                    })
                }
                return;
            };
            const userDetail = argsAll?.userDetail;
            const isAdmin = isAdminUser(userDetail);
            let userSettingValue = Utils.convertJSONDataToObject(userDetail?.userSetting);
            let corporationDetail = argsAll?.corporationDetail;

            if (
                userSettingValue?.adminMode === Constant.ADMIN_MODE.ON &&
                isAdmin &&
                corporationDetail?.rootFlag
            ) {
                await argsAll.addNewPanel({
                    type: Constant.PANEL_TYPE.ROOT_ORG_EDIT_CONTRACT,
                    tabId: sourceInfo.corporationId,
                    props: argsAll.props,
                    orgId: sourceInfo.corporationId,
                    orgName: sourceInfo.organizationName
                });
            }
            break;
        case NotificationEventType.OVER_MAX_RESOURCES:
        case NotificationEventType.NOTI_YOURS_CONTRACT_HAVE_BEEN_UPDATED:
            const isAdmins = isAdminUser(argsAll.userDetail);
            let userSettingValues = Utils.convertJSONDataToObject(argsAll.userDetail?.userSetting);

            if (
                userSettingValues.adminMode === Constant.ADMIN_MODE.ON &&
                isAdmins
            ) {
                await argsAll.addNewPanel({
                    type: Constant.PANEL_TYPE.SYSTEM_MANAGEMENT,
                    tabId: Constant.TAB_PANEL_TYPE.SYSTEM_NORMAL_CONTRACT_DETAIL,
                    props: argsAll.props,
                });
            }
            
            if (
                notification.eventType === NotificationEventType.NOTI_YOURS_CONTRACT_HAVE_BEEN_UPDATED && 
                userSettingValues.adminMode !== Constant.ADMIN_MODE.ON &&
                isAdmins
            ) {
                argsAll.setShowPopupAdminModeOff(true);
            }
            break;
        default:
            break;
    }
};

const openPanelUserProfile = argsAll => {
    argsAll.addNewPanel({
        type: Constant.PANEL_TYPE.PERSONAL_MANAGEMENT,
        tabId: Constant.PANEL_TYPE.SYSTEM_USER_PROFILE,
        props: argsAll.props
    });
};



/**
 * getAllNotificationOfUser
 * @param {*} API 
 * @param {*} projectList 
 * @param {*} page 
 * @param {*} notificationList 
 * @returns 
 */
export const getAllNotificationOfUser = async (API, projectList, page = 1) => {
    const type = Constant.TYPE_GET_NOTIFICATION_LIST.ALL;
    const limit = 30;
    let corporationId = localStorageUtil.getAffiliationOrganization();
    let userId = localStorageUtil.getUserDetailId();

    let eachPageParams = {
        userId: userId,
        corporationId: corporationId,
        projectList: !Utils.isEmptyArray(projectList) ? JSON.stringify(projectList) : '',
        type: type,
        page: page,
        limit: limit
    };

    let queryNotiResult = await getUserNotificationListByParams(API, eachPageParams);
    let notificationList = !Utils.isEmptyArray(queryNotiResult.notificationList)
        ? queryNotiResult.notificationList
        : [];
    return notificationList;
};


/**
 * validateBeforeViewCorporationRootSide
 * @param {*} API 
 * @param {*} corporationId 
 * @returns 
 */
const validateBeforeViewCorporationRootSide = async (API, corporationId) => {
    if (!API || !corporationId) return false;

    let corpData = await getCorporationById(API, corporationId);
    if (!corpData || corpData?.active === Constant.CORPORATION_ACTIVE.DELETED) return false;

    return true;
}

export const onScrollPanelNotify = async (
    e,
    setIsLoading,
    setNotificationList,
    API,
    setCurrentPage,
    currentPage,
    projectList
) => {
    let scrollableDiv = e.target;

    const scrollHeight = scrollableDiv.scrollHeight;
    const scrollTop = scrollableDiv.scrollTop;
    const clientHeight = scrollableDiv.clientHeight;

    if (scrollHeight - scrollTop === clientHeight) {
        setIsLoading(true);
        // get project list
        if (Utils.isEmptyArray(projectList)) {
            return [];
        }

        let projectListRequest = [];
        projectList.forEach(project => {
            projectListRequest.push({ id: project.id, createdAt: project.userAddAt });
        });

        let nextPage = currentPage + 1;
        let noticationList = await getAllNotificationOfUser(API, projectListRequest, nextPage);

        if(Utils.isEmptyArray(noticationList)) {
            setIsLoading(false);
            return;
        }

        setCurrentPage(prev => prev + 1);
        noticationList.forEach(msg => {
            msg.notificationMsg = getNotificationMsg(msg);
        });

        noticationList = noticationList.filter(msg => msg.notificationMsg !== '');
        noticationList = Utils.sortByCreatedAtDesc(noticationList);
        setNotificationList(prev => [...prev, ...noticationList]);
        setIsLoading(false);
    }
};

export const getUserNotificationList = async (corporationId, userId) => {
    let projectList = await getListAllProjectOfUser(null, corporationId, userId);
    
    // get project list
    if (Utils.isEmptyArray(projectList)) {
        return [];
    }

    let projectListRequest = [];
    projectList.forEach(project => {
        projectListRequest.push({ id: project.id, createdAt: project.userAddAt });
    });

    let noticationList = await getAllNotificationOfUser(
        null,
        projectListRequest
    );

    noticationList.forEach(msg => {
        msg.notificationMsg = getNotificationMsg(msg);
    });

    noticationList = noticationList.filter(msg => msg.notificationMsg !== '');

    // sort by desc createdAt
    noticationList = Utils.sortByCreatedAtDesc(noticationList);

    return noticationList;
}